export enum FileSyncStatus {
  Synced = 'Synced',
  Syncing = 'Syncing',
}
